export const widgetApiTimeout = {
    event: "homepageRevamp",
    eventCategory: "Homepage_revamp",
    eventAction: "timeout_server",
    eventLabel: "fail"
};
